import React, { useEffect, useState } from 'react'
import { Segmented,Form,Input,Button,Select,Space, Tooltip, message } from 'antd'
import './style.css'
import { PlusCircleOutlined } from '@ant-design/icons'
import { TbTrashFilled } from 'react-icons/tb'
import axios from 'axios'
import { SERVER_ADDRESS } from '../../Config/Config'

const AddCountry = () => {
    const [selectedOption,setSelectedOption] = useState('Country')
    const [country,setCountry] = useState([])
    const [state,setState] = useState([])
    const [form] = Form.useForm();
    const [stateform] = Form.useForm();
    const [cityform] = Form.useForm();

    const fetchCountry = async()=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/fetchCountry`,{type:1})
        if(response.status === 200 && response.data.result === 1){
          const options = response.data.data.map((item)=>({
            label:item.country,
            value:item.id
          }))
          setCountry(options)
        }
        else{
          message.error({content:"Something went Wrong"})
        }
      } catch (error) {
        message.error({content:"Something went Wrong"})
      }
    }

    const fetchState = async(country_id)=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/fetchCountry`,{type:2,country_id})
        if(response.status === 200 && response.data.result === 1){
          const options = response.data.data.map((item)=>({
            label:item.state,
            value:item.id
          }))
          setState(options)
        }
      } catch (error) {
        console.log(error)
        message.error({content:"Something went wrong"})
      }
    }

    const handleCountryChange = (country_id)=>{
      fetchState(country_id)
    }

    useEffect(()=>{
      fetchCountry()
    },[selectedOption])

    const onFinish = async(values)=>{
      const data = values[selectedOption.toLowerCase()].map((item) =>{
        return({
          country: item[selectedOption.toLowerCase()],
          code: item.code
        })
      });
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/addCountry`,{type:1,data})
            if(response.status === 200 && response.data.result === 1 ){
                message.success({content:`${response.data.message}`})
                form.resetFields()
            }
        } catch (error) {
            message.error({content:"Something Went Wrong !"})
        }
    }

    const handleState = async(values)=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/addCountry`,{type:2,data:values})
        if(response.status === 200 && response.data.result === 1 ){
          message.success({content:`${response.data.message}`})
          stateform.resetFields();
        }
        if(response.data.result===0){
          message.warning({content:`${response.data.message}`})
        }
      } catch (error) {
        message.error({content:"Somthing went wrong !"})
      }
    }

    const handleCity = async(values)=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/addCountry`,{type:3,data:values})
        if(response.status === 200 && response.data.result === 1 ){
          message.success({content:`${response.data.message}`})
          cityform.resetFields();
        }
        if(response.data.result===0){
          message.warning({content:`${response.data.message}`})
        }
      } catch (error) {
        message.error({content:"Somthing went wrong !"})
      }
    }

    const renderForm = ()=>{
        switch (selectedOption) {
            case 'Country':
               return (
                <Form form={form} onFinish={onFinish} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                <Form.List name={selectedOption.toLowerCase()}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                          <Form.Item label='Country' 
                            {...restField}
                            name={[name, selectedOption.toLowerCase()]}
                            rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                          >
                            <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                          </Form.Item>
                          <Form.Item label='Code' name={[name,'code']} rules={[{ required: true, message: `Enter ${selectedOption} Code` },{ len: 3, message: 'Code must be exactly 3 characters long' }]} >
                            <Input placeholder={`Enter ${selectedOption} code`} style={{width:"10rem"}} />
                          </Form.Item>
                          {fields.length > 1 && (
                            <Tooltip title='Remove Row' >
                                <Button color="danger" variant='filled' onClick={() => remove(name)}>
                                    <TbTrashFilled />
                                </Button>
                            </Tooltip>
                          )}
                        </Space>
                      ))}
                      <Form.Item wrapperCol={{offset:2}} >
                      <Tooltip title='Add Row' >
                        <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() =>  add({ [selectedOption.toLowerCase()]: '', code: '' })} block>
                            <PlusCircleOutlined />
                        </Button>
                      </Tooltip>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
        
                <Form.Item wrapperCol={{offset:6}} >
                  <Button type="primary" htmlType="submit">
                    Submit {selectedOption}
                  </Button>
                </Form.Item>
                </Form>
                )
            case 'State':
                return (
                  <Form form={stateform} onFinish={handleState} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                    <Form.Item label='Country' name='country_id' rules={[{required:true,message:"Select Country"}]} style={{width:"33.2rem"}} >
                          <Select
                          showSearch
                            placeholder="Select a Country"
                            options={country}
                            optionFilterProp="label"
                            filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                          />
                            </Form.Item>
                  <Form.List name={selectedOption.toLowerCase()}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                            <Form.Item  wrapperCol={{offset:1}} label='State' 
                              {...restField}
                              name={[name, selectedOption.toLowerCase()]}
                              rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                            >
                              <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                            </Form.Item>
                            {fields.length > 1 && (
                              <Tooltip title='Remove Row' >
                                  <Button style={{marginLeft:"1.3rem"}} color="danger" variant='filled' onClick={() => remove(name)}>
                                      <TbTrashFilled />
                                  </Button>
                              </Tooltip>
                            )}
                          </Space>
                        ))}
                        <Form.Item wrapperCol={{offset:2}} >
                        <Tooltip title='Add Row' >
                          <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() => add({})} block>
                              <PlusCircleOutlined />
                          </Button>
                        </Tooltip>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
          
                  <Form.Item wrapperCol={{offset:6}} >
                    <Button type="primary" htmlType="submit">
                      Submit {selectedOption}
                    </Button>
                  </Form.Item>
                  </Form>
                )
            case 'City':
                return (
                  <Form form={cityform} onFinish={handleCity} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                  <Form.Item label='Country' name='country_id_1' labelCol={{offset:3}} rules={[{required:true,message:"Select Country"}]} style={{width:"33.2rem"}} >
                        <Select
                        showSearch
                        onChange={(value)=>{
                          handleCountryChange(value)
                        }}
                          placeholder="Select a Country"
                          options={country}
                          optionFilterProp="label"
                          filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                        />
                    </Form.Item>
                    <Form.Item label='State' name='state_id' labelCol={{offset:3}} rules={[{required:true,message:"Select Country"}]} style={{width:"33.2rem"}} >
                        <Select
                        showSearch
                          placeholder="Select a State"
                          options={state}
                          optionFilterProp="label"
                          filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                        />
                    </Form.Item>
                <Form.List name={selectedOption.toLowerCase()}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space key={key} style={{ display: 'flex',flexDirection:"column" ,marginBottom: 8 }} align="baseline">
                          <Form.Item labelCol={{offset:3}} label='City' 
                            {...restField}
                            name={[name, selectedOption.toLowerCase()]}
                            rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                          >
                            <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                          </Form.Item>
                          <Form.Item labelCol={{offset:3}} label='Latitude' 
                            {...restField}
                            name={[name, 'lati']}
                            rules={[{ required: true, message: `Enter ${selectedOption} Latitude` },{ pattern: /^-?\d+(\.\d+)?$/, message: 'Please enter a valid latitude' },]}
                          >
                            <Input placeholder={`Enter ${selectedOption} Latitude`} style={{width:"30rem"}} />
                          </Form.Item>
                          <Form.Item labelCol={{offset:3}} label='Longitude' 
                            {...restField}
                            name={[name, 'longi']}
                            rules={[{ required: true, message: `Enter ${selectedOption} Longitude` },{ pattern: /^-?\d+(\.\d+)?$/, message: 'Please enter a valid longitude' },]}
                          >
                            <Input placeholder={`Enter ${selectedOption} Longitude`} style={{width:"30rem"}} />
                          </Form.Item>
                          {fields.length > 1 && (
                            <Tooltip title='Remove Row' >
                                <Button style={{marginLeft:"1.3rem"}} color="danger" variant='filled' onClick={() => remove(name)}>
                                    <TbTrashFilled />
                                </Button>
                            </Tooltip>
                          )}
                        </Space>
                      ))}
                      <Form.Item wrapperCol={{offset:2}} >
                      <Tooltip title='Add Row' >
                        <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() => add({})} block>
                            <PlusCircleOutlined />
                        </Button>
                      </Tooltip>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
        
                <Form.Item wrapperCol={{offset:6}} >
                  <Button type="primary" htmlType="submit">
                    Submit {selectedOption}
                  </Button>
                </Form.Item>
                </Form>
                )
            default:
                break;
        }
    }

    const options = ['Country','State','City']
  return (
    <div style={{marginTop:'4rem'}} >
        <Segmented color='' options={options} block selected={selectedOption} onChange={setSelectedOption} />
        <div className='mt-3 p-4' style={{backgroundColor:"white",borderRadius:"1rem"}}  >
          <h3 className='py-4' >{selectedOption} Form</h3>
            {renderForm()}
        </div>
    </div>
  )
}

export default AddCountry